import { useCallback, useEffect } from "react";
import useState from "react-usestateref";
import { ConverterUtil } from "../_util";
import { KeyboardSensor, PointerSensor, useSensor, useSensors, DragStartEvent, DragEndEvent } from "@dnd-kit/core";
import { sortableKeyboardCoordinates, arrayMove } from "@dnd-kit/sortable";
import { findIndex } from "lodash";
import { useHomeUsePluginContainer } from "../../../../custom-hooks/HomeUsePluginRoot";
import useFeatureTags from "../../../../custom-hooks/useFeatureTags";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";

export default function useAiSaasOutput(props?: AISaasOutput.AiSaasOutputListProps) {
  const { thoughtOptions = [], onChangeThoughts } = props || {};
  const { isShare } = useHomeUsePluginContainer();
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const [activeId, setActiveId] = useState<string | number | null>(null);

  const [modifiers] = useState([restrictToVerticalAxis]);
  const { enablePreviewDragNode } = useFeatureTags();
  const disabledDnd = !enablePreviewDragNode;

  // 为其增加id, 将原有 thoughts 转换成 dnd 列表
  const [dndThoughts, setDndThoughts, dndThoughtsRef] = useState(() => {
    return ConverterUtil.toDndData(thoughtOptions);
  });

  // const _onChangeThoughts = (thoughts: AISaasOutput.DndThoughtType[]) => {
  const _onChangeThoughts = (thoughts: AISaasOutput.DndThoughtWithGroupType[]) => {
    setDndThoughts(thoughts);
    onChangeThoughts?.(ConverterUtil.toAiSaasThoughts(thoughts));
  };

  const sortById = (oldId: string | number, newId: string | number) => {
    const items = dndThoughtsRef.current;
    const oldIndex = findIndex(items, item => item.id === oldId);
    const newIndex = findIndex(items, item => item.id === newId);
    const newItems = arrayMove(items, oldIndex, newIndex);
    _onChangeThoughts(newItems);
  };

  useEffect(() => {
    const newDndOptions = ConverterUtil.toDndData(thoughtOptions);
    setDndThoughts(newDndOptions);
    // TODO: 深度比较
  }, [thoughtOptions]);
  // }, [JSON.stringify(thoughtOptions)]);

  const onDragStart = useCallback((event: DragStartEvent) => {
    const { active } = event;
    setActiveId(active.id);
  }, []);

  const onDragEnd = useCallback((event: DragEndEvent) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      sortById(active.id, over.id);
    }

    setActiveId(null);
  }, []);

  const onClickSortable: AISaasOutput.OnClickSortableHandler = useCallback(({ id, type }) => {
    const targetIndex = findIndex(dndThoughtsRef.current, item => item.id == id);
    const length = dndThoughtsRef.current.length;

    // 保证当是在第1个元素和倒数第二个元素内
    if (targetIndex == -1) {
      return;
    }

    if (type === "up" && targetIndex >= 1) {
      const over = dndThoughtsRef.current.at(targetIndex - 1);
      over && sortById(id, over.id);
    }

    if (type === "down" && targetIndex <= length - 2) {
      const over = dndThoughtsRef.current.at(targetIndex + 1);
      over && sortById(id, over.id);
    }
  }, []);

  return {
    ...props,
    dndThoughts,
    sensors,
    activeId,
    setActiveId,
    onDragStart,
    onDragEnd,
    onClickSortable,

    isShare,
    disabledDnd,

    /**
     * 拖拽修改器
     *
     * - 目前是只运行垂直拖拽
     *
     * @see https://docs.dndkit.com/api-documentation/modifiers
     */
    modifiers,
  };
}
